module.exports = __webpack_public_path__ + "static/media/resume-analyzer.a3859444.png";